import logo from './logo.svg';
import './App.css';
import LandingPage from './Pages/LandingPage/LandingPage';

function App() {
  return (
    <div className="App">
     <LandingPage/>
    </div>
  );
}

export default App;
